var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 15.5L9.18754 10.9375L10.9375 9.18749L15.5 13.75L13.75 15.5ZM2.25004 15.5L0.500041 13.75L6.25004 7.99999L4.83337 6.58332L4.25004 7.16666L3.18754 6.10416V7.81249L2.60421 8.39582L0.083374 5.87499L0.666707 5.29166H2.37504L1.33337 4.24999L4.29171 1.29166C4.56949 1.01388 4.8681 0.81249 5.18754 0.68749C5.50699 0.56249 5.83337 0.49999 6.16671 0.49999C6.50004 0.49999 6.82643 0.56249 7.14587 0.68749C7.46532 0.81249 7.76393 1.01388 8.04171 1.29166L6.12504 3.20832L7.16671 4.24999L6.58337 4.83332L8.00004 6.24999L9.87504 4.37499C9.81949 4.22221 9.77435 4.06249 9.73962 3.89582C9.7049 3.72916 9.68754 3.56249 9.68754 3.39582C9.68754 2.57638 9.96879 1.88541 10.5313 1.32291C11.0938 0.760407 11.7848 0.479156 12.6042 0.479156C12.8125 0.479156 13.0105 0.49999 13.198 0.541656C13.3855 0.583323 13.5764 0.645823 13.7709 0.729156L11.7084 2.79166L13.2084 4.29166L15.2709 2.22916C15.3681 2.4236 15.4341 2.61457 15.4688 2.80207C15.5035 2.98957 15.5209 3.18749 15.5209 3.39582C15.5209 4.21527 15.2396 4.90624 14.6771 5.46874C14.1146 6.03124 13.4237 6.31249 12.6042 6.31249C12.4375 6.31249 12.2709 6.2986 12.1042 6.27082C11.9375 6.24305 11.7778 6.19443 11.625 6.12499L2.25004 15.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.2bdc746b6d621e6cd6982c073c5b7f95.svg";
export { ForwardRef as ReactComponent };